import type {ThemeOptions} from '@mui/material';
import type {} from '@mui/x-data-grid/themeAugmentation';

export const outerTheme: ThemeOptions = {
	palette: {
		mode: 'dark',
	},
	typography: {
		fontFamily: "'Roboto', 'Inter', sans-serif",
		fontWeightLight: 300,
		fontWeightRegular: 400,
		fontWeightMedium: 500,
		fontWeightBold: 700,
		h1: {
			fontSize: '3.75rem',
			lineHeight: 1.2,
			letterSpacing: '-0.5px',
		},
		h2: {
			fontSize: '3rem',
			lineHeight: 1.167,
			letterSpacing: '0px',
		},
		h3: {
			fontSize: '2.125rem',
			lineHeight: 1.235,
			letterSpacing: '0.25px',
		},
		h4: {
			fontSize: '1.5rem',
			lineHeight: 1.334,
			letterSpacing: '0px',
		},
		h5: {
			fontSize: '1.25rem',
			lineHeight: 1.6,
			letterSpacing: '0.15px',
		},
		h6: {
			fontSize: '1rem',
			lineHeight: 1.6,
			letterSpacing: '0.15px',
		},
		subtitle1: {
			fontSize: '0.875rem',
			lineHeight: 1.57,
			letterSpacing: '0.1px',
		},
		subtitle2: {
			fontSize: '0.75rem',
			lineHeight: 1.5,
			letterSpacing: '0.1px',
		},
		body1: {
			fontSize: '0.875rem',
			lineHeight: 1.5,
			letterSpacing: '0.15px',
		},
		body2: {
			fontSize: '0.75rem',
			lineHeight: 1.43,
			letterSpacing: '0.15px',
		},
		button: {
			fontSize: '0.75rem',
			lineHeight: 1.75,
			letterSpacing: '0.4px',
			textTransform: 'none',
		},
		caption: {
			fontSize: '0.6875rem',
			lineHeight: 1.66,
			letterSpacing: '0.4px',
		},
		overline: {
			fontSize: '0.6875rem',
			lineHeight: 2.66,
			letterSpacing: '1.5px',
			textTransform: 'uppercase',
		},
	},
	components: {
		MuiBottomNavigationAction: {
			styleOverrides: {
				label: {
					fontSize: '0.75rem',
					'&.Mui-selected': {
						fontSize: '0.75rem',
					},
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: 'none',
					cursor: 'pointer',
					userSelect: 'none',
				},
			},
			defaultProps: {
				disableElevation: true,
			},
		},
		MuiIconButton: {
			styleOverrides: {
				root: {
					'&:focus, &:focus-visible': {
						outline: 'none',
						boxShadow: 'none',
					},
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiInputBase-input': {
						fontSize: '0.75rem',
						fontWeight: '200 !important',
					},
					'& .MuiInputAdornment-root': {
						fontSize: '0.75rem !important',
						fontWeight: '200 !important',
					},
					'& .MuiInputAdornment-root .MuiTypography-root': {
						fontSize: '0.75rem !important',
						fontWeight: '200 !important',
					},
					'& .MuiFormHelperText-root': {
						fontSize: '0.75rem',
						fontWeight: 400,
					},
				},
			},
		},
		MuiCssBaseline: {
			styleOverrides: {
				'*': {
					scrollbarWidth: 'thin',
				},
				'*::-webkit-scrollbar': {
					width: '8px',
					height: '8px',
				},
				'*::-webkit-scrollbar-track': {
					background: 'transparent',
				},
				'*::-webkit-scrollbar-thumb': {
					borderRadius: '4px',
				},
				html: {
					scrollbarWidth: 'thin',
				},
				body: {
					scrollbarWidth: 'thin',
				},
			},
		},
	},
};
